import { TapiConfig } from './base';
import { mockRequests } from './envVars.testUtil';

// This triggers an error in the editor, because of the global tsconfig,
// but works just fine when using vite

const FiveMinutes = 1 * 1000 * 60 * 5;

export const getDevelopmentConfig: (base: TapiConfig) => TapiConfig = (
  base
) => {
  return {
    ...base,
    mockRequests,
    requests: {
      healthStatus: {
        pollingInterval: FiveMinutes,
      },
      campaignAlerts: {
        pollingInterval: FiveMinutes,
      },
      matchesStats: {
        pollingInterval: FiveMinutes,
      },
      completesStats: {
        pollingInterval: FiveMinutes,
      },
      quotaStats: {
        pollingInterval: FiveMinutes,
      },
      campaignFieldingStats: {
        pollingInterval: FiveMinutes,
      },
    },
  };
};
